import { createContext, type ReactNode, useContext, useRef } from 'react'

import type { FormFieldComponents } from './types'

const FormFieldsContext = createContext<FormFieldComponents | null>(null)

interface FormFieldsProviderProps {
  children: ReactNode
  components: FormFieldComponents
}

export const FormFieldsProvider = ({
  children,
  components,
}: FormFieldsProviderProps) => {
  const stable = useRef(components).current

  return (
    <FormFieldsContext.Provider value={stable}>
      {children}
    </FormFieldsContext.Provider>
  )
}

export const useFormFieldComponent = <K extends keyof FormFieldComponents>(
  name: K
): NonNullable<FormFieldComponents[K]> => {
  const ctx = useContext(FormFieldsContext)
  if (!ctx) throw new Error('FormFieldsProvider is missing')

  const component = ctx[name]
  if (!component) throw new Error(`Form field "${name}" is not registered`)

  return component as NonNullable<FormFieldComponents[K]>
}
